export default __webpack_public_path__ + "static/media/telephone.9d35f339.svg";